import { SharedPackItemController } from './shared-pack-item.controller'

const component = {
  templateUrl: '/core/components/shared-pack-item/shared-pack-item.html?$$REVISION$$',
  bindings: {
    packItem: '<',
    viewMode: '@', // "ADMIN" | "GUEST"
    onItemUpdate: '&',
    tooltipBottom: '<'
  },
  controllerAs: '$ctrl',
  controller: SharedPackItemController
}

export const sharedPackItem = component
